import React from 'react';
import { FiCalendar } from 'react-icons/fi';
import { RANGES } from './dateRange';

// Period filter as five calendar buttons (7, 15, 30, 90 days, all time); styled by .rc-chips in customerListing.css.
const RangeChips = ({ value, onChange }) => (
  <div className="rc-chips" role="group" aria-label="Period">
    {RANGES.map((r) => (
      <button
        key={r}
        type="button"
        className={`rc-chip${value === r ? ' on' : ''}`}
        aria-pressed={value === r}
        title={r === 'all' ? 'All time' : `Last ${r} days`}
        aria-label={r === 'all' ? 'All time' : `Last ${r} days`}
        onClick={() => onChange(r)}
      >
        <FiCalendar size={15} />
        <span>{r === 'all' ? 'All' : `${r}d`}</span>
      </button>
    ))}
  </div>
);

export default RangeChips;
